import type { Queryfilter as QueryFilter } from '@gonfalon/queryfilter/builder';
import type { PostContextsParams } from '@gonfalon/rest-api/types';

// SDK type re-exports
// oxlint-disable no-restricted-imports -- This package owns the canonical Gonfalon re-export.
export type {
  LDEvaluationReason,
  LDContext,
  LDSingleKindContext,
  LDMultiKindContext,
  LDContextCommon,
} from 'launchdarkly-js-sdk-common';
// oxlint-enable no-restricted-imports

// Context kind key enum for built-in context kinds
export enum ContextKindKey {
  USER = 'user',
  APPLICATION = 'ld_application',
  DEVICE = 'ld_device',
}

// Application types
export type ContextTargetKindKey = { kind: string; key: string };

// UI view state types for context lists and filtering
export type UIContextsView = Omit<PostContextsParams, 'filter'> & {
  filter?: QueryFilter;
};

export type UIContextsKindsView = {
  offset?: number;
  query?: string;
};

export type ContextKind = {
  key: string;
  name: string;
  description?: string;
  /**
   * When true, render as a plain option (name + description) without the key code badge.
   * For non-kind meta options such as the targeting clause's "target the context kind
   * rather than an attribute" choice, which reuses this shape but has no real key to show.
   */
  hideKey?: boolean;
  version?: number;
  archived?: boolean;
  hidden?: boolean;
  creationDate?: number;
  lastModified?: number;
  lastSeen?: number;
  createdFrom?: string;
};

export type ContextAttributesName = {
  name: string;
  count?: number;
  redacted?: boolean;
};

export type ContextAttributesNames = {
  kind: string;
  names: ContextAttributesName[];
};

export type ContextAttributesResponse = {
  items: ContextAttributesNames[];
};
